import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const RetencionTarjetaCabal = ({ data, selectCombo, selectCheckBox }) => {
    const { GET_RETENCION_TARJETA_CABAL } = data;
    let arrayAux = GET_RETENCION_TARJETA_CABAL.filter(d => d.Checked);
    let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
    let letraNminuscula = ExpHelper.ConvertirCaracter("n");
    const acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Retenci" + acentoLetraOminuscula + "n de Tarjeta"}</label>
                <div className="container-radio radio-margin">

                    <CheckDefecto nombre={"Se" + letraNminuscula + "al de Retenci" + acentoLetraOminuscula + "n de Tarjeta"}
                        referencia={"HabilitarRetencionTarjeta"}
                        check={data.HabilitarRetencionTarjeta}
                        selectCheckBox={({ target }) => selectCheckBox("HabilitarRetencionTarjeta", target.checked)} />

                    <div className="row">

                        {data.HabilitarRetencionTarjeta && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                            {GET_RETENCION_TARJETA_CABAL.map((item) => {
                                const referencia = `RTCL-${item.Id}`;

                                return (
                                    <CheckDefecto
                                        key={item.Id}
                                        nombre={item.Descripcion}
                                        check={item.Checked}
                                        activo={item.Activo}
                                        referencia={referencia}
                                        selectCheckBox={() => {
                                            if (data.HabilitarRetencionTarjeta) {
                                                selectCheckBox("GET_RETENCION_TARJETA_CABAL", item.Id);
                                            }
                                        }}
                                    />
                                )
                            })}
                        </div>}

                        <div className="col-xs-12">
                            {data.HabilitarRetencionTarjeta && <OpcionDefecto
                                infoData={arrayAux}
                                referencia={"RetencionTarjetaDefaultId"}
                                valorCombo={data.RetencionTarjetaDefaultId}
                                valorChecked={data.RetencionTarjetaDefaultInterfaz}
                                selecciono={arrayAux.length}
                                selectCombo={(value) => selectCombo("RetencionTarjetaDefaultId", value)}
                                selectCheckBox={(value) => selectCheckBox("RetencionTarjetaDefaultInterfaz", value)}
                            />}

                            {(data.ERROR_PRODUCT["seleccionoRetencionTarjeta"] == false && arrayAux.length<1) ? <label className="error">{"Debe seleccionar al menos una señal de retención de tarjeta."}</label> : null}


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RetencionTarjetaCabal;